import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AutosuggestSearch from '@components/common/autosuggest_search/main';
import Checkbox from '@components/common/checkbox/main';
import _ from 'underscore';

const TagsFilter = (props) => {
  const [allTags, setAllTags] = useState([]);
  const [visibleTags, setVisibleTags] = useState([]);
  const { searchableThings, tags, updateFilters } = props;
  const tagsFiltered = tags;

  useEffect(() => {
    if (searchableThings.tags !== undefined) {
      setAllTags(searchableThings.tags);
      setVisibleTags(searchableThings.tags.slice(0, 10));
    }
  }, [searchableThings]);

  const checkAndUpdateTags = (tag) => {
    if (visibleTags.length > 10) {
      const hasFilter = visibleTags.slice(10).filter((filter) => filter.name === tag);

      if (hasFilter.length > 0) {
        const visibleTagsUpdated = allTags.slice(0, 10);
        setVisibleTags(visibleTagsUpdated);
      }
    }
    updateFilters(tag);
  };

  const updateTags = (suggestion) => {
    const visibleTagsUpdated = [...visibleTags];

    updateFilters(suggestion.name);
    visibleTagsUpdated.push(suggestion);
    setVisibleTags(visibleTagsUpdated);
  };

  if (allTags.length <= 0) { return null; }
  return (
    <div className="filter-section tags">
      <div className="flex-row title">
        <span>{t('Top Tags')}</span>
      </div>
      <div className="tag-columns">
        {visibleTags.map((tag) => {
          const name  = tag.name;
          const count = tag.count;
          return (
            <div className="tag-item" key={name}>
              <Checkbox
                size="sm"
                checked={tagsFiltered.indexOf(name.replace('"', '\\"')) > -1}
                toggle={() => checkAndUpdateTags(name)}
                label={name}
              />
              <div className="tag-count">{count}</div>
            </div>
          );
        })}
      </div>
      { _.difference(allTags, visibleTags).length === 0 ? '' : (
        <AutosuggestSearch
          id="tag-autosuggest"
          allValues={allTags}
          visibleValues={visibleTags}
          onSelect={updateTags}
        />
      )}
    </div>
  );
};

TagsFilter.propTypes = {
  searchableThings: PropTypes.shape({}).isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
  updateFilters: PropTypes.func.isRequired,
};

TagsFilter.defaultProps = {
  tags: [],
};

export default TagsFilter;
